import { Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/auth/ProtectedRoute'
import Layout from './components/layout/Layout'

// Auth pages
import LoginPage from './pages/auth/LoginPage'
import InvitationAcceptPage from './pages/auth/InvitationAcceptPage'
import TwoFactorPage from './pages/auth/TwoFactorPage'

// App pages
import HomePage from './pages/HomePage'
import DashboardPage from './pages/DashboardPage'
import InvitationsPage from './pages/InvitationsPage'
import ProjectsPage from './pages/projects/ProjectsPage'
import ProjectDetailPage from './pages/projects/ProjectDetailPage'
import AnalysesDashboardPage from './pages/analyses/AnalysesDashboardPage'
import AnalysisDetailPage from './pages/analyses/AnalysisDetailPage'
import SynchroChangelog from './pages/analyses/SynchroChangelog'

function App() {
  return (
    <AuthProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            duration: 5000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/invitation/:token" element={<InvitationAcceptPage />} />
        <Route path="/2fa" element={<TwoFactorPage />} />

        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/projects/:id" element={<ProjectDetailPage />} />
            <Route path="/analyses" element={<AnalysesDashboardPage />} />
            <Route path="/analyses/:id" element={<AnalysisDetailPage />} />
            <Route path="/analyses/synchro-parser/changelog" element={<SynchroChangelog />} />
            <Route path="/invitations" element={<InvitationsPage />} />
          </Route>
        </Route>

        {/* Catch all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  )
}

export default App
